import createCache from '@emotion/cache';

const insertionPoint = document.createElement('meta');
insertionPoint.setAttribute('name', 'tss-insertion-point');
document.head.prepend(insertionPoint);

const tssCache = createCache({ key: 'tss', insertionPoint });

export default tssCache;
